module.exports = __webpack_public_path__ + "img/yishu1.87ad86e8.png";